//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_INDICES = "obtenerIndices";
export const OBTENER_INDICE = "obtenerIndice";
export const REGISTRAR_INDICE = "registrarIndice";
export const ACTUALIZAR_INDICE = "actualizarIndice";
// mutation types
export const SET_INDICES = "setIndices";
export const SET_INDICE = "setIndice";

const state = {
    indices:[],
    data: [{id:1, nombreIndice: 'Participación Ciudadana', estadosId: 1, estado: 'Activo', descripcionIndice: 'Mide el compromiso de las autoridades municipales por aplicar principios y procedimientos de participación efectiva e incluyente,'+
    'de la ciudadanía y actores municipales en procesos de decisión como lo es la planificación y ejecución de las políticas públicas de'+ 
    'desarrollo. También valora políticamente el  desempeño del Comude como el espacio de discusión  de temas relevantes y de rendición de cuentas.'}, 
{id:2, nombreIndice: 'Información a la Ciudadania', estadosId: 1, estado: 'Activo', descripcionIndice: 'Mide el compromiso de la municipalidad de asumir como parte de su gestión, la práctica de informar y rendir cuentas a la ciudadanía,'+ 
    'sobre procesos, programas o proyectos que se aprueban y ejecutan, de igual manera sobre los efectos en las condiciones de vida de la población.'+ 
    'Identifica si se enfocan en resultados, además si aplica mecanismos que permiten el acceso a  información pública.'},
{id:3, nombreIndice: 'Gestión de Servicios Públicos', estadosId: 2, estado: 'Inactivo', descripcionIndice: 'Mide la cobertura y calidad de los servicios públicos prestados por la municipalidad que por competencia debe establecer,'+ 
    'mantener, ampliar y mejorar, garantizando el  funcionamiento  eficaz, seguro y continuo de los mismos.  El cumplir con esta competencia,'+  
    'favorece los procesos de desarrollo social y económico del municipio y la mejora de la calidad de vida de los habitantes.'},
{id:4, nombreIndice: 'Gestión Administrativa', estadosId: 1, estado: 'Activo', descripcionIndice: 'Mide las fortalezas administrativas que poseen las municipalidades a nivel de recursos humanos, atención al vecino y una estructura'+ 
   'organizativa debidamente normada.'}],
    indice:[]
}

const getters = {
    obtenerIndices(state) {
      return state.puestos;
    },
}

const actions = {
    /**
     * Obtener el listado de índices
     * @param {*} context 
     * @param {*} estadoId 
     * @returns 
     */
    async [OBTENER_INDICES](context, estadoId) {
        let endpoint = 'api/Indices'
        if(estadoId){
            endpoint = `api/Indices/Estado/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_INDICES, data.data);
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });  
    },

    async [OBTENER_INDICE](context, id){
        
        /*return new Promise(resolve => {
            let items = state.data.filter(item => {
                return item.id === id

              });
              
              const obj = Object.assign({}, ...items);
               // console.log(obj)

            let fakeData= {
                data: obj, 
                status: 200, 
                message: 'Índices obtenidos con éxito'
            };

            //console.log(item)
            context.commit(SET_INDICE, fakeData.data);
            resolve(fakeData);

        });*/
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Indices/`)
                .then(({ data }) => {
                    context.commit(SET_INDICE, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    async [REGISTRAR_INDICE](context, datosIndice){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Indices`, datosIndice)
                .then(({ data }) => {
                    context.commit(SET_INDICE, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [ACTUALIZAR_INDICE](context, datosIndice){
        let id = datosIndice.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Indices/`, datosIndice)
                .then(({ data }) => {
                    context.commit(SET_INDICE, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }

}

const mutations = {
    [SET_INDICES](state, data) {
        state.indices = data;
    },

    [SET_INDICE](state, data) {
        state.indice = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}